// @flow

import split from 'lodash/fp/split';
import zipObject from 'lodash/fp/zipObject';
import compose from 'lodash/fp/compose';
import { dateTimeFormat } from '@active/awe-ui-core/lib/services/formatDateTime';

export const splitLong = (date: string, timeZone: string, locale: string) => compose(
  zipObject([ 'month', 'day', 'year' ]),
  split(' '),
)(dateTimeFormat(locale, timeZone, date, 'MMM d yyyy'));
